export default __webpack_public_path__ + "static/media/gwm-label-2x.715d312f.png";